<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_b"></a><span class="font"><strong>ALSO BY STEPHEN AMIDON</strong></span></p>
<p class="linespace"> </p>
<p class="center-paraa"><em>Human Capital</em></p>
<p class="center-paraa"><em>The New City</em></p>
<p class="center-paraa"><em>The Primitive</em></p>
<p class="center-paraa"><em>Thirst</em></p>
<p class="center-paraa"><em>Splitting the Atom</em></p>
<p class="center-paraa"><em>Subdivision: Stories</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?672e14be